import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { generateGetItineraryForCounterEndpoint } from '../../../../config/endpoints';
import withEndpointAuthorization from '../../authorization/withEndPointAuthorization';
import ResourceProperty from '../../../common/resource/ResourceProperty';
import { GET } from '../../../../config/permissions';
import { ITINERARY_FOR_COUNTER_PATH } from '../../../../config/paths';

export const TicketItineraryLabel = ({ itineraryId }) => (
  <ResourceProperty label="Itinerario:">
    {itineraryId ? (
      <a
        href={`${ITINERARY_FOR_COUNTER_PATH}/${itineraryId}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        {itineraryId}
      </a>
    ) : (
      '-'
    )}
  </ResourceProperty>
);

TicketItineraryLabel.propTypes = {
  itineraryId: PropTypes.number.isRequired,
};

const connectedComponent = connect(null, null)(TicketItineraryLabel);

export default withEndpointAuthorization({
  url: generateGetItineraryForCounterEndpoint(0),
  permissionType: GET,
})(connectedComponent);
